import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const NewWindowIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M15 1H9.05v1h4.24L6.88 8.41l.71.71L14 2.71v4.24h1V1Z M10.5 8.35V14H2V5.5h5.65v-1H1V15h10.5V8.35h-1Z" />
  </IconWrapper>
)

export default NewWindowIconSmall
